import React, { useCallback, useState } from 'react';
import { Button, Text } from '@goodfynd/ui';
import classnames from 'clsx';

import type { ToggleOptions } from './types';

import classes from './ToggleButtons.module.css';

export function ToggleButtons<T>({
  className,
  onChange,
  options = [],
  value,
}: ToggleOptions<T>) {
  const [selectedValue, setSelectedValue] = useState(value);

  const render = useCallback(
    () => (
      <aside className={classnames(classes['toggle-container'], className)}>
        {options.map((option) => (
          <Button
            display="compact"
            key={String(option.value)}
            size="small"
            className={classnames(classes['toggle-button'], {
              [classes['selected']]: selectedValue === option.value,
            })}
            onClick={() => {
              setSelectedValue(option.value);
              onChange?.(option.value);
            }}
          >
            <Text
              tag="span"
              className={classnames(classes['button-text'], {
                [classes['selected']]: selectedValue === option.value,
              })}
            >
              {option.label || String(option.value)}
            </Text>
          </Button>
        ))}
      </aside>
    ),
    [className, onChange, options, selectedValue]
  );

  return render();
}
